const steps = [
  { num: 1, day: "Day 1", title: "要件確定", desc: "データ/環境整備、スコープ確定" },
  { num: 2, day: "Day 2", title: "実装開始", desc: "AIを活用した実装、日次レビュー" },
  { num: 3, day: "Day 3", title: "実装継続", desc: "フィードバック反映、方向修正" },
  { num: 4, day: "Day 4", title: "機能完成", desc: "テスト実施、品質確認" },
  { num: 5, day: "Day 5", title: "成果物提示", desc: "デモ、レポート提出、次フェーズ提案" },
];

const packages = [
  {
    id: "s",
    special: true,
    industryBadge: "製造業特化",
    name: "パッケージS",
    campaignBadge: "キャンペーン限定",
    title: "案件管理 改善プラン",
    priceBefore: "100万円",
    price: "50万円",
    period: "(税別)/ 1週間",
    note: "通常100万円の内容を、製造業向けの特別限定プランとして50万円でご提供します。",
    approval: "キャンペーン限定の特別価格",
    features: [
      "案件の一覧・検索・進捗管理ができるWebアプリ",
      "納期が近い案件を毎朝自動でお知らせ",
      "担当者・得意先などの情報を一元管理",
      "操作マニュアル・引き継ぎ資料",
      "毎日の進捗レビュー",
    ],
  },
  {
    id: "a",
    special: false,
    name: "パッケージA",
    title: "技術検証プラン",
    price: "100万円",
    period: "(税別)/ 1週間",
    approval: "小規模検証向け",
    features: [
      "動くプロトタイプ(MVP)",
      "技術検証レポート(AI活用可能性の分析)",
      "本開発に向けた概算見積もり",
      "毎日の進捗レビュー",
      "期間中の仕様変更対応",
    ],
  },
  {
    id: "b",
    special: false,
    recommended: true,
    name: "パッケージB",
    title: "超高速MVP検証プラン",
    price: "200万円",
    period: "(税別)/ 2週間",
    approval: "本格導入前検証向け",
    features: [
      "本番デプロイ可能なプロトタイプ(URL形式)",
      "定量分析レポート(AI活用効果の数値化)",
      "ROI予測資料(上司・役員説明用)",
      "AI活用ノウハウ共有セッション(2時間)",
      "毎日の進捗レビュー",
      "期間中の仕様変更対応",
    ],
  },
];

export default function Packages() {
  return (
    <section id="packages" className="bg-white py-20">
      <div className="max-w-5xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-extrabold text-gray-900 mb-3">PoC開発、ご提案パッケージ</h2>
          <p className="text-gray-500 text-sm">目的・予算に合わせた3つのプランをご用意しました</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {packages.map((pkg) => (
            <div
              key={pkg.id}
              className={`relative rounded-2xl p-7 flex flex-col ${
                pkg.recommended
                  ? "bg-blue-600 text-white border-2 border-blue-500"
                  : pkg.special
                  ? "bg-white border-2 border-amber-400"
                  : "bg-white border border-gray-200"
              }`}
            >
              {pkg.recommended && (
                <div className="absolute -top-4 left-1/2 -translate-x-1/2">
                  <span className="bg-blue-400 text-white text-xs font-bold px-4 py-1.5 rounded-full whitespace-nowrap">
                    おすすめ
                  </span>
                </div>
              )}
              {pkg.industryBadge && (
                <span className="inline-block bg-orange-500 text-white text-xs font-bold px-3 py-1 rounded-full mb-3 whitespace-nowrap w-fit">
                  {pkg.industryBadge}
                </span>
              )}
              <div className="flex items-center gap-2 flex-wrap mb-1">
                <span className={`text-base font-extrabold ${pkg.recommended ? "text-white" : "text-gray-900"}`}>
                  {pkg.name}
                </span>
                {pkg.campaignBadge && (
                  <span className="bg-amber-400 text-white text-xs font-bold px-2 py-0.5 rounded-full whitespace-nowrap">
                    {pkg.campaignBadge}
                  </span>
                )}
              </div>
              <div className={`text-sm mb-3 ${pkg.recommended ? "text-blue-100" : "text-gray-500"}`}>
                {pkg.title}
              </div>
              <div className="mb-1">
                {pkg.priceBefore && (
                  <span className="text-gray-400 line-through text-sm mr-2">{pkg.priceBefore}</span>
                )}
                <span className={`text-3xl font-extrabold ${pkg.recommended ? "text-white" : "text-gray-900"}`}>
                  {pkg.price}
                </span>
                <span className={`text-xs ml-1 ${pkg.recommended ? "text-blue-100" : "text-gray-400"}`}>
                  {pkg.period}
                </span>
              </div>
              <div className={`text-xs mb-3 ${pkg.recommended ? "text-blue-100" : "text-gray-400"}`}>
                {pkg.approval}
              </div>
              {pkg.note && (
                <p className="text-xs text-amber-700 bg-amber-50 border border-amber-100 rounded-lg px-3 py-2 mb-4 leading-relaxed">
                  {pkg.note}
                </p>
              )}
              <ul className="space-y-2 mb-6 flex-1">
                {pkg.features.map((f) => (
                  <li key={f} className="flex items-start gap-2 text-xs">
                    <span className={`mt-0.5 w-4 h-4 flex items-center justify-center flex-shrink-0 ${pkg.recommended ? "text-blue-200" : "text-blue-500"}`}>
                      <i className="ri-check-line text-sm"></i>
                    </span>
                    <span className={pkg.recommended ? "text-blue-50" : "text-gray-600"}>{f}</span>
                  </li>
                ))}
              </ul>
              <a
                href="#contact"
                className={`block text-center font-bold text-sm py-3 rounded-full transition-colors whitespace-nowrap cursor-pointer ${
                  pkg.recommended
                    ? "bg-white text-blue-700 hover:bg-blue-50"
                    : pkg.special
                    ? "bg-amber-400 text-white hover:bg-amber-500"
                    : "bg-blue-600 text-white hover:bg-blue-700"
                }`}
              >
                このパッケージで相談する
              </a>
            </div>
          ))}
        </div>
        <div className="text-center mt-14">
          <a
            href="#contact"
            className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white font-semibold px-6 py-3 rounded-full transition-colors text-sm whitespace-nowrap cursor-pointer"
          >
            <i className="ri-gift-line text-lg" />
            まずは無料でモック作成を依頼 →
          </a>
          <p className="text-gray-400 text-xs mt-3">翌日には動くモックが手元に届きます</p>
        </div>

        <div className="mt-20 pt-16 border-t border-gray-100">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl font-extrabold text-gray-900 mb-3">一週間でPoCを実現</h2>
            <p className="text-gray-500 text-sm">1週間の開発の流れ(パッケージA)</p>
          </div>
          <div className="flex flex-col md:flex-row items-start gap-0 md:gap-0 relative">
            {steps.map((step, i) => (
              <div key={step.num} className="flex-1 flex flex-col items-center text-center relative">
                {i < steps.length - 1 && (
                  <div className="hidden md:block absolute top-6 left-1/2 w-full h-0.5 bg-blue-100 z-0"></div>
                )}
                <div className="w-12 h-12 rounded-full bg-blue-600 text-white flex items-center justify-center font-extrabold text-lg z-10 mb-3">
                  {step.num}
                </div>
                <div className="text-xs font-bold text-blue-500 mb-1">{step.day}</div>
                <div className="text-sm font-bold text-gray-900 mb-1">{step.title}</div>
                <div className="text-xs text-gray-500 leading-relaxed px-2">{step.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
